import { DisplayTypeEnum } from "api/files";
import { GenericColors } from "api/tenant";
import { toasterService } from "components/feedback/Toaster/toasterService";
import { useDialog } from "hooks/useDialog";
import { FC, useEffect, useState } from "react";

import { realEstateAPI } from "services/swagger-api/realEstateAPI";
import { BienPicker } from "./BienPicker";

interface CreateParcModalProps {
  ownerId: string;
  onCreated: () => void;
}

export const CreateParcModal: FC<CreateParcModalProps> = ({ ownerId, onCreated }) => {
  const { setDialogActions, closeDialog } = useDialog();
  const [name, setName] = useState('');
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!name.trim() || selectedIds.length === 0 || isSubmitting) return;
    setIsSubmitting(true);
    try {
      const response = await realEstateAPI.createParc({
        createParcImmobilierCommandDto: {
          name: name.trim(),
          ownerId,
          realEstateIds: selectedIds
        }
      });
      if (response.isSuccess) {
        toasterService.showToast({
          message: "Parc créé avec succès.",
          displayType: DisplayTypeEnum.Toaster,
          color: GenericColors.Green
        });
        onCreated();
        closeDialog();
      } else {
        toasterService.showToast({
          message: response.errorMessage || "Erreur lors de la création du parc.",
          displayType: DisplayTypeEnum.Toaster,
          color: GenericColors.Red
        });
      }
    } catch (error) {
      console.error("Erreur lors de la création du parc:", error);
      toasterService.showToast({
        message: "Erreur lors de la création du parc.",
        displayType: DisplayTypeEnum.Toaster,
        color: GenericColors.Red
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    setDialogActions({
      submitLabel: "COMMON.CREATE",
      closeLabel: "COMMON.CANCEL",
      submitDisabled: !name.trim() || selectedIds.length === 0 || isSubmitting,
      onSubmit: handleSubmit
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, selectedIds, isSubmitting]);

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Nom du parc</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Ex : Portefeuille locatif Paris"
          className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-primary focus:border-primary"
        />
      </div>

      <BienPicker personId={ownerId} onSelectionChange={setSelectedIds} />
    </div>
  );
};
